export default "__VITE_ASSET__jzyUmJTe__"